import {
  React, Accordion, AccordionPanel, CollapsedContent, _n,
} from 'pexui';
import * as utils from '../../utilities/utils';
import { DocUploadService } from '../../services/docuploadsvc';
import { getTrackLabel } from '../../models/flow';
import { track, setTrackOpts } from '../../utilities/track';
import { Button, RadioButon, Link } from '../comps/uicomps';
import { Html } from '../comps/html';
import { uploadAFile, FileButton, FilesList } from './files';
import { stopBusy } from '../comps/busy';
import globals from '../../models/globals';

const shouldShowUploadButton = (node) => {
  const uploadCompleted = utils.findArray(node.files, file => !file.completedTime) == null;
  return !uploadCompleted;
};

export const DocUploadPane = ({
  page, node, widget, flow, className,
}) => {
  const { req } = flow;
  const docType = node.widgetOption ? node.widgetOption.document_type : '';
  const showsUploadButton = shouldShowUploadButton(node);

  const uploadParams = {
    message_id: utils.randomString(12),
    transaction_id: req.transaction_id,
    originator_id: req.originator_id,
    docupld_request_id: req.transaction_id,
    market: req.market,
    account_number: req.document_data.process_control_number,
    business_unit_code: req.document_data.business_unit_code,
    customer_id: node.account.customer_id || '',
    organization_id: node.account.organization_id || '',
    offer_details_code: req.document_data.offer_details_code,
    document_type: docType, // 'UNAUDITED FINANCIALS',
    docupld_tid: flow.docUploadTids[node.code] || '',
    docupld_token: flow.docupld_token || '',
    personal_info: req.personal_info || '',
    member_number: req.account_number || '',
    is_single_sign_on: req.is_single_sign_on || false,
  };

  const onAttachSuccess = (file, resp) => {
    if (resp.response_code !== 0) {
      throw new Error('response_code should be 0!');
    }
    const finalArrayItem = resp.file_list.slice(-1)[0];
    const docupld_fid = finalArrayItem ? finalArrayItem.docupld_fid : '';
    const updatedName = finalArrayItem ? finalArrayItem.name : '';

    node.files.push({
      type: 'file',
      size: file.size,
      originalName: file.name,
      updatedName,
      fid: docupld_fid,
      completedTime: null,
    });
    node.messages = [];

    flow.setCurrentNode(node);
    stopBusy();


    // attached
    track('AddFile:Attached', { contentName: getTrackLabel(node) });
    page.forceUpdate();
  };

  const onAttachError = (err, errorKey) => {
    flow.addNodeMessage(node, err, errorKey);
    flow.setCurrentNode(node);
    stopBusy();
    page.forceUpdate();
  };

  const onUploadClicked = () => {
    flow.lastChannel = 'DOCUPLOAD';
    node.messages = [];
    DocUploadService.confirmUpload({
      transaction_id: req.transaction_id,
      originator_id: req.originator_id,
      account_number: req.document_data.process_control_number,
      market: req.market,
      document_type: docType, // 'TAX TRANSCRIPT',
      docupld_tid: flow.docUploadTids[node.code],
      docupld_request_id: req.transaction_id,
      docupld_token: flow.docupld_token,
      customer_id: node.account.customer_id || '',
      organization_id: node.account.organization_id || '',
      offer_details_code: req.document_data.offer_details_code,
      document_type: node.widgetOption ? node.widgetOption.document_type : '',
    }, node.code).then(
      (resp) => {
        stopBusy();
        if (
          resp.submit_statuses
                    && Array.isArray(resp.submit_statuses)
                    && resp.submit_statuses.length > 0
        ) {
          resp.submit_statuses.forEach((statusItem) => {
            if (statusItem.hasOwnProperty('file_name')) {
              const fileName = statusItem.file_name;
              node.files.forEach((file) => {
                if (
                  utils.filenameMatches(
                    file.updatedName,
                    fileName
                  )
                ) {
                  file.successCode = statusItem.success_code
                                        || statusItem.error_code
                                        || 'error';
                  file.message = statusItem.message || '';
                  file.artifactUrn = statusItem.artifact_urn;
                  file.completedTime = new Date();
                }
              });
            }
          });

          flow.raiseInvokerEvent('docUploadResponse', {
            transaction_id: req.transaction_id,
            process_control_number:
                            req.document_data.process_control_number,
            submission_channel_code: 'DOCUPLD',
            documents_requested_code: node.code,
            received_timestamp: utils.getTimestamp(),
            customer_id: node.account.customer_id, // In case of CPS
            organization_id: node.account.organization_id, // In case of OPEN
            docupload_response: resp.submit_statuses,
          });
        } else {
          const submit_statuses = [];
          node.files.forEach((file) => {
            if (!file.completedTime) {
              file.successCode = 'INGESTED';
              file.message = '';
              file.completedTime = new Date();

              submit_statuses.push({
                success_code: 'INGESTED',
                file_name: file.updatedName,
              });
            }
          });

          flow.raiseInvokerEvent('docUploadResponse', {
            transaction_id: req.transaction_id,
            process_control_number:
                            req.document_data.process_control_number,
            submission_channel_code: 'DOCUPLD',
            documents_requested_code: node.code,
            received_timestamp: utils.getTimestamp(),
            customer_id: node.account.customer_id, // In case of CPS
            organization_id: node.account.organization_id, // In case of OPEN
            docupload_response: submit_statuses,
          });
        }

        track('AddFile:Success', {
          contentName: getTrackLabel(node),
        });

        page.forceUpdate();
      },
      (err) => {
        node.files = (node.files || [])
          .filter(file => !!file.completedTime);
        setTrackOpts('AddFile', {
          contentName: getTrackLabel(node),
        });

        flow.addNodeMessage(node, err);
        flow.setCurrentNode(node);
        stopBusy();
        page.forceUpdate();
      }
    );
  };

  return (
    <div className={className}>
      {showsUploadButton ? (
        <Button
          id={utils.getUniqueId('infw_btn_upload', node)}
          className="infw-btn-secondary margin-b"
          label={_n('document.upload')}
          busyZone="widget"
          onClick={onUploadClicked}
        />
      ) : (
        ''
      )}
      {[
        <FileButton
          id={utils.getUniqueId('infw_btn_attach', node)}
          className="infw-btn-secondary"
          label={node.files.length > 0 ? _n('button_morefile.label') : _n('button_attachfile.label')}
          node={node}
          params={uploadParams}
          onUploaded={onAttachSuccess}
          onError={onAttachError}
        />,
        <Html
          className="infw-btn-desc"
          hideEmpty={true}
          content="DocUpload.button_desc"
        />,
      ]}
    </div>
  );
};



// WEBPACK FOOTER //
// ./application/src/views/docupload/docupload.jsx